"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var dayjs_1 = __importDefault(require("dayjs"));
var chevron_left_24_svg_1 = __importDefault(require("@/assets/svg/chevron-left-24.svg"));
var chevron_right_24_svg_1 = __importDefault(require("@/assets/svg/chevron-right-24.svg"));
var Styled = __importStar(require("./DatePicker.styled"));
var utils_1 = require("@/utils");
var handleGenerateDateRows = function (date) {
    var rows = (0, utils_1.rangeArray)(date.daysInMonth()).reduce(function (_a, _, index) {
        var accRows = _a.accRows, accRowIndex = _a.accRowIndex;
        var currentIndexDate = (0, dayjs_1.default)(new Date(date.year(), date.month(), index + 1));
        accRows[accRowIndex].push(currentIndexDate);
        if (currentIndexDate.day() === 6 && index !== date.daysInMonth() - 1) {
            return { accRows: __spreadArray(__spreadArray([], __read(accRows), false), [[]], false), accRowIndex: accRowIndex + 1 };
        }
        return { accRows: accRows, accRowIndex: accRowIndex };
    }, { accRows: [[]], accRowIndex: 0 }).accRows;
    return rows.map(function (each, index) {
        if (index === 0 && each.length !== 7) {
            return __spreadArray(__spreadArray([], __read((0, utils_1.rangeArray)(7 - each.length).map(function (_, i) { return each[0].clone().startOf('week').add(i, 'day'); })), false), __read(each), false);
        }
        if (index === rows.length - 1 && each.length !== 7) {
            return __spreadArray(__spreadArray([], __read(each), false), __read((0, utils_1.rangeArray)(7 - each.length).map(function (_, i) {
                return each[each.length - 1].clone().add(i + 1, 'day');
            })), false);
        }
        return each;
    });
};
var CALENDAR_COLUMN = ['일', '월', '화', '수', '목', '금', '토'];
var DayCell = function (_a) {
    var date = _a.date, current = _a.current, selectedDate = _a.selectedDate, _b = _a.disablePast, disablePast = _b === void 0 ? false : _b, resetProps = __rest(_a, ["date", "current", "selectedDate", "disablePast"]);
    var today = (0, dayjs_1.default)();
    var isCurrentMonth = date.month() === current.month();
    var isDisabled = (disablePast && date.isBefore(today) && !date.isSame(today, 'day')) || !isCurrentMonth;
    var props = __assign(__assign({}, resetProps), { disabled: isDisabled, today: date.isSame(today, 'day'), selected: date.isSame(selectedDate, 'year') &&
            date.isSame(selectedDate, 'month') &&
            date.isSame(selectedDate, 'date') });
    return (0, jsx_runtime_1.jsx)(Styled.DatePickerTd, __assign({}, props, { children: date.format('D') }), void 0);
};
var DatePicker = function (_a) {
    var className = _a.className, handleSelectDate = _a.handleSelectDate, selectedDate = _a.selectedDate, _b = _a.disablePast, disablePast = _b === void 0 ? false : _b;
    var _c = __read((0, react_2.useState)(selectedDate !== null && selectedDate !== void 0 ? selectedDate : (0, dayjs_1.default)()), 2), date = _c[0], setDate = _c[1];
    var rows = handleGenerateDateRows(date);
    var handleChangeMonth = function (by) {
        if (by === 'next') {
            return setDate(date.clone().add(1, 'month'));
        }
        setDate(date.clone().subtract(1, 'month'));
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.DatePickerWrapper, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)(Styled.DatePickerHeader, { children: [(0, jsx_runtime_1.jsx)(chevron_left_24_svg_1.default, { onClick: function () { return handleChangeMonth('prev'); } }, void 0), (0, jsx_runtime_1.jsx)("div", { children: date.format('YYYY.M') }, void 0), (0, jsx_runtime_1.jsx)(chevron_right_24_svg_1.default, { onClick: function () { return handleChangeMonth('next'); } }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.DatePickerTable, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: CALENDAR_COLUMN.map(function (column) { return ((0, jsx_runtime_1.jsx)("th", { children: column }, column)); }) }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("tbody", { children: rows.map(function (row, i) { return ((0, jsx_runtime_1.jsx)("tr", { children: row.map(function (d) { return ((0, jsx_runtime_1.jsx)(DayCell, { date: d, current: date, selectedDate: selectedDate, disablePast: disablePast, onClick: function () { return handleSelectDate(d.clone()); } }, "td-".concat(d.date()))); }) }, "tr-".concat(row[i].date()))); }) }, void 0)] }, void 0)] }), void 0));
};
exports.default = DatePicker;
